import { useLocation, useNavigate } from "react-router-dom";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ListItemButton, ListItemIcon, ListItemText, Tooltip, Collapse, ListSubheader, Divider, List, Box, Menu, MenuItem } from '@mui/material';
import { useState, useEffect } from "react";
import { palette } from "../theme";

const Item = ({ data, header, isCollapsed, selected, setSelected }) => {
  const [open, setOpen] = useState(false);
  const [groupSelected, setGroupSelected] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  
  const navigate = useNavigate();
  const location = useLocation();

  const isMenuOpen = Boolean(anchorEl);

  const handleClick = (to, title) => {
    window.sessionStorage.setItem("selectedTab", title);
    setSelected(to);
    handleCloseMenu();
    if (location.pathname === to) {
      navigate(0);
    } else {
      navigate(to);
    }
  };

  const handleOpenMenu = (event) => {
    if (isCollapsed) {
      setAnchorEl(event.currentTarget);
    } else {
      setOpen(!open);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Il gruppo si apre quando la pagina corrente è una sua voce e resta aperto finché non lo
  // chiude l'utente (o si comprime la sidebar): prima veniva richiuso a ogni render in cui
  // la voce attiva non coincideva esattamente col path, facendo perdere il riferimento.
  useEffect(() => {
    if (Array.isArray(data)) {
      const match = data.some((item) => {
        if (!item.to) return false;
        const path = item.to.split("?")[0];
        return location.pathname === path || location.pathname.startsWith(path + "/");
      });
      if (isCollapsed) setOpen(false);
      else if (match) setOpen(true);
      setGroupSelected(match);
    }
  }, [location.pathname, isCollapsed, data]);

  // RENDER PER ITEM SINGOLO (Senza sotto-menu)
  if (!Array.isArray(data)) {
    if (!data.to) {
      return isCollapsed ? <Divider sx={{ my: 1 }} /> : <ListItemText>{data.title}</ListItemText>;
    }

    const button = (
      <ListItemButton
        onClick={() => !data.disabled && handleClick(data.to, data.title)}
        selected={selected === data.to}
        disabled={data.disabled}
      >
        <ListItemIcon>{data.icon}</ListItemIcon>
        {!isCollapsed && <ListItemText primary={data.title} />}
      </ListItemButton>
    );

    // Un item disabled non riceve eventi mouse dal DOM (l'attributo `disabled`
    // sopprime pointer-events), quindi il Tooltip va agganciato a uno <span>
    // che lo racchiude -- altrimenti l'hover non lo apre mai.
    const tooltipTitle = data.disabled ? (data.disabledReason || data.title) : data.title;
    return (isCollapsed || data.disabled) ? (
      <Tooltip title={tooltipTitle} placement="right" arrow>
        <span>{button}</span>
      </Tooltip>
    ) : button;
  }

  // RENDER PER GRUPPO (Con sotto-menu)
  const headerButton = (
    <ListItemButton
      onClick={handleOpenMenu}
      selected={groupSelected}
      
    >
      <ListItemIcon>{header.icon}</ListItemIcon>
      {!isCollapsed && (
        <>
          <ListItemText primary={header.title} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </>
      )}
    </ListItemButton>
  );

  return (
    <>
      {isCollapsed ? (
        <Tooltip title={header.title} placement="right" arrow>
          {headerButton}
        </Tooltip>
      ) : headerButton}

      {isCollapsed ? (
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleCloseMenu}
          placement="right-start"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          slotProps={{
            paper: {sx: {backgroundColor: palette.background.paper}},
            list: {sx: {px: 1}}
          }}
        >
          <ListItemText>{header.title}</ListItemText>
          {data.map((item) => (
            item.to ? (
              <MenuItem
                key={item.to}
                onClick={() => !item.disabled && handleClick(item.to, item.title)}
                selected={selected === item.to}
                disabled={item.disabled}
              >
                 <ListItemIcon>{item.icon}</ListItemIcon>
                 {item.title}
              </MenuItem>
            ) : <ListSubheader><ListItemText sx={{ml:1, fontSize: 12}}>{item.title}</ListItemText></ListSubheader>
          ))}
        </Menu>
      ) : (
        <Collapse in={open} timeout={'auto'} unmountOnExit>
          <List component="div" disablePadding>
            {data.map((item, index) => (
              <Box key={item.to || index}>
                {item.to ? (
                   <ListItemButton
                    onClick={() => handleClick(item.to, item.title)}
                    selected={selected === item.to}
                    sx={{ pl: 4 }}
                    disabled={item.disabled}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItemButton>
                ) : (
                  <ListItemText sx={{ pl: 2 }}>{item.title}</ListItemText>
                )}
              </Box>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default Item;